var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCmsTeams(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 576 576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 288,
    r: 187.81,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 288,
    r: 216,
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M238.6,297.51a70.35,70.35,0,1,0-70.35-70.35A70.35,70.35,0,0,0,238.6,297.51Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.53,524.51V401.85A64.29,64.29,0,0,1,319.64,339a48.7,48.7,0,0,0-35.13-15.09H166.78a49,49,0,0,0-48.89,48.88V564.42a49,49,0,0,0,48.89,48.88H284.51A48.83,48.83,0,0,0,327,588.12C294.3,585.16,268.53,557.93,268.53,524.51Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,235a53,53,0,1,0,53,53A53.08,53.08,0,0,0,380,235Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.11,532.52V393.84c0-20.95-18.92-38-42.17-38h-83a49.17,49.17,0,0,1,.58,5.15V570.51h82.43C439.19,570.51,458.11,553.47,458.11,532.52Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.74,355.84h-.33c-26.42,0-47.9,17.05-47.9,38V532.52c0,21,21.48,38,47.9,38h1V361A44.46,44.46,0,0,0,332.74,355.84Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmsTeams);
export default __webpack_public_path__ + "static/media/CMS_Teams.3cc190dde1f0af894dc89cd07e025e06.svg";
export { ForwardRef as ReactComponent };